import { Component } from 'react';
import styled from 'styled-components';
import { Position } from '../../../../../../../domain/model/notice/INoticeRepository';
import NoticeItemMainColumn from './NoticeItemMainColumn';
import NoticeItemSubColumn from './NoticeItemSubColumn';

interface IProps {
  type: 'announce' | 'mediatag';
  mediaTagId?: string;
  position: Position;
  contents: Array<{
    title: string;
    description?: string;
    linkUrl?: string;
    imageUrl?: string;
    pos?: number;
  }>;
  index: number;
  rsec: string;
}

const Wrapper = styled.div`
  /* メインカラムお知らせ：お知らせが続く場合余白をつける */
  /* 隣接セレクタがバリアント固有のクラス名に展開されないため、カスタムデータ属性を使用 */
  &[data-position='${Position.MAIN_TOP}'] + &[data-position='${Position.MAIN_TOP}'] {
    margin-top: 8px;
  }
`;

export default class NoticeContents extends Component<IProps> {
  /**
   *
   */
  public render() {
    const noticeItems = this.props.contents.map((noticeItem, itemIndex) => {
      // mediaTag連携のお知らせの場合はmediaTagのIdを付与
      const customLoggerParam =
        this.props.type === 'mediatag' && this.props.mediaTagId
          ? `_cl_vmodule:${this.props.rsec};_cl_link:mt_title;_cl_position:${noticeItem.pos ?? 0};tagid:${
              this.props.mediaTagId
            };`
          : `_cl_vmodule:${this.props.rsec};_cl_link:title;_cl_position:${noticeItem.pos ?? 0};`;
      return this.props.position === Position.MAIN_TOP ? (
        <NoticeItemMainColumn
          {...noticeItem}
          customLoggerParam={customLoggerParam}
          key={`${this.props.position}_${this.props.index}_${itemIndex}`}
        />
      ) : (
        <NoticeItemSubColumn
          {...noticeItem}
          customLoggerParam={customLoggerParam}
          key={`${this.props.position}_${this.props.index}_${itemIndex}`}
        />
      );
    });
    return <Wrapper data-position={this.props.position}>{noticeItems}</Wrapper>;
  }
}
